<div class="Dialog" mat-dialog-content>
  <div>
    <p>Are you sure you want to remove this favorited item?</p>
  </div>
  <mat-dialog-actions>
    <button mat-button [mat-dialog-close]="true" class="ThemeColorAccent">Yes, remove it</button>
    <button mat-button cdkFocusInitial [mat-dialog-close]="false" class="ThemeColorAccent">No, keep it</button>
  </mat-dialog-actions>
</div>
